module.exports = __webpack_public_path__ + "img/0-74.38ba1c69.jpg";